import { Footer } from './ui/Footer.jsx'

export default Footer
